import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalHeading,
} from '@uikit';

import { useEmailLoginError } from '@shared/common/providers/GlobalModalsProvider';

export default function EmailLoginError() {
  const errorModal = useEmailLoginError();

  const handleClose = () => {
    errorModal.close();
  };

  return (
    <Modal {...errorModal.props}>
      <ModalContent className="p-0 max-w-[600px]">
        <ModalCloseButton className="m-4" />

        <div className="px-12 pb-6 flex flex-col items-center">
          <ModalHeading className="mb-7">Unavailable</ModalHeading>

          <ModalDescription className="mb-12 text-neutral-600 font-semibold">
            Oops! Your Magic Link has expired after 10 minutes or it has already been used. Please
            request a new one to log in to the Magic Store.
          </ModalDescription>
          <Button variant="primary" onClick={handleClose} size="lg" className="px-10">
            Ok
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
}
